import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Unidad } from '../../models/unidad';
import { Servicio } from '../../models/servicio';
import { Menu } from '../../models/menu';

@Injectable({
    providedIn: 'root'
})
export class DataService {

    public idiomaSource = new BehaviorSubject<string>('es');
    private tituloSource = new BehaviorSubject<string>('');
    private idServicioSpaSource = new BehaviorSubject<number>(0);

    private parametrosSource = new BehaviorSubject<any>('');
    currentParametros = this.parametrosSource.asObservable();

    private unidadesSource = new BehaviorSubject<Array<Unidad>>([]);
    currentUnidades = this.unidadesSource.asObservable();

    private unidadesOtrosSource = new BehaviorSubject<Array<Unidad>>([]);
    currentOtrosUnidades = this.unidadesOtrosSource.asObservable();

    private urlSource = new BehaviorSubject<string>('');
    currentUrl = this.urlSource.asObservable();

    private unidadSelectedSource = new BehaviorSubject<any>({});
    currentUnidadSelected = this.unidadSelectedSource.asObservable();

    private unidadOtrosSelectedSource = new BehaviorSubject<Unidad>(new Unidad());
    currentUnidadOtrosSelected = this.unidadOtrosSelectedSource.asObservable();

    private casinoJuegoSelectedSource = new BehaviorSubject<any>([]);
    currentCasinoJuegoSelected = this.casinoJuegoSelectedSource.asObservable();

    private footerMenuSource = new BehaviorSubject<any>([]);
    currentFooterMenu = this.footerMenuSource.asObservable();

    private servicioSource = new BehaviorSubject<Array<Servicio>>([]);
    currentServicio = this.servicioSource.asObservable();

    private origenSource = new BehaviorSubject<string>('H');
    currentOrigen = this.origenSource.asObservable();

    private origenEspectaculoSource = new BehaviorSubject<string>('HE');
    currentOrigenEspectaculo = this.origenEspectaculoSource.asObservable();

    constructor() { }

    public $idioma = this.idiomaSource.asObservable();

    public $titulo = this.tituloSource.asObservable();

    public $idServicioSpa = this.idServicioSpaSource.asObservable();

    public changeParametros(parametros: any) {
        this.parametrosSource.next(parametros);
    }

    public changeUnidades(unidades: Array<Unidad>) {
        this.unidadesSource.next(unidades);
    }

    public changeUnidadesOtros(unidades: Array<Unidad>) {
        this.unidadesOtrosSource.next(unidades);
    }

    public changeUrl(value: string) {
        this.urlSource.next(value);
    }

    public changeUnidadSelected(value: any) {
        this.unidadSelectedSource.next(value);
    }

    public changeCasinoJuegoSelected(value: any) {
        this.casinoJuegoSelectedSource.next(value);
    }

    public changeFooterMenu(value: Array<any>) {
        this.footerMenuSource.next(value);
    }

    public changeServicio(value: Array<Servicio>) {
        this.servicioSource.next(value);
    }

    public changeServicioData(value: Array<Menu>) {
        this.servicioSource.next(value);
    }

    setIdioma(value: string) {
        this.idiomaSource.next(value);
    }

    setTitulo(value: string) {
        this.tituloSource.next(value);
    }

    setServicioSpa(value: number) {
        this.idServicioSpaSource.next(value);
    }

    public changeOrigenSelected(value: any) {
        this.origenSource.next(value);
    }

    public getOrigen(): string {
        return this.origenSource.getValue();
    }

    public changeOrigenEspectaculoSelected(value: any) {
        this.origenEspectaculoSource.next(value);
    }

    public getOrigenEspectaculo(): string {
        return this.origenEspectaculoSource.getValue();
    }
}
